import { Controller } from "@hotwired/stimulus";

// Fires posthog.capture(eventValue, propertiesValue) when triggered.
//
// Usage:
//   <a href="/somewhere"
//      data-controller="posthog-track"
//      data-posthog-track-event-value="og_event_teaser_clicked"
//      data-posthog-track-properties-value='{"event_id":123}'
//      data-action="click->posthog-track#track">
//
// For links/buttons that navigate away immediately, set
// data-posthog-track-transport-value="sendBeacon" so the event survives the
// page unload (a plain capture is dropped under request batching).
// For something that happened before the page rendered -- an order that just
// completed, say -- set data-posthog-track-on-connect-value="true" and leave
// off the data-action.
export default class extends Controller {
  static values = {
    event: String,
    properties: { type: Object, default: {} },
    transport: { type: String, default: "" },
    onConnect: { type: Boolean, default: false },
  };

  connect() {
    if (this.onConnectValue) this.track();
  }

  track() {
    if (typeof window.posthog === "undefined" || !window.posthog.capture) {
      return;
    }
    const options = this.transportValue
      ? { transport: this.transportValue }
      : {};
    window.posthog.capture(this.eventValue, this.propertiesValue, options);
  }
}
